import { useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './participants.module.scss';
import EventParticipantTag from './EventParticipantTag';

function EventParticipant({
  contacts = [],
  agents = [],
  trackCallback = null,
  ...props
}) {
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);

  const firstAgentId = agents?.[0]?.id;
  const singleAgentFiltered =
    selectedIds?.length === 1 && selectedIds[0] === firstAgentId;

  const renderAgents = agents?.length > 0 && !singleAgentFiltered;

  return (
    <Box __css={props} className={styles.eventParticipantContainer}>
      <EventParticipantTag
        participants={contacts}
        trackCallback={trackCallback}
      />
      {renderAgents && (
        <EventParticipantTag
          participants={agents}
          type="agent"
          trackCallback={trackCallback}
        />
      )}
    </Box>
  );
}

export default EventParticipant;
